import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '@environment';
import {
  TranslatedCityUrls,
  TranslatedContractsUrls,
  TranslatedDomainUrls,
} from '@features/directories/translated-urls';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Bookmark } from '@models/profile/bookmark';
import { Profile } from '@models/profile/profile';
import { Select } from '@ngxs/store';
import { DirectoriesRoutingEnum } from '@routing/directories/directories-routing.enum';
import { ProfileState } from '@store/ngxs-profile/profile.state';
import { ApplicationStoreService } from '@store/profile/application-store.service';
import { BookmarkState } from '@store/profile/bookmark/bookmark.state';
import { SessionState } from '@store/session/session.state';
import { buildPath } from '@wizbii/angular-utilities';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-job-layout',
  templateUrl: './job-layout.component.html',
  styleUrls: ['./job-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobLayoutComponent {
  applicationsTotal$: Observable<number>;

  @Select(SessionState.isLogged) isLogged$: Observable<boolean>;
  @Select(ProfileState.authenticatedProfile) profile$: Observable<Profile>;
  @Select(BookmarkState) bookmarkMap$: Observable<Map<string, Bookmark>>;

  companiesUrl = buildPath(FeaturesRoutingEnum.Directories, DirectoriesRoutingEnum.Entreprises);
  jobsUrl = buildPath(FeaturesRoutingEnum.Directories, DirectoriesRoutingEnum.Jobs);

  domainsJobsUrl = TranslatedDomainUrls[environment.lang];
  jobsCitiesUrl = TranslatedCityUrls[environment.lang];
  jobsContractsUrl = TranslatedContractsUrls[environment.lang];

  constructor(private readonly applicationStoreService: ApplicationStoreService) {
    this.applicationsTotal$ = this.applicationStoreService.total$;
  }
}
